import React from "react";
import ReactDOM from "react-dom/client";
import ReactModal from "react-modal";
import "./index.scss";
import posthog from "posthog-js";

import Root from "components/Root";

import { PostHogProvider } from "posthog-js/react";
import { AnalyticsWrapper, JSS_LICENSE_KEY } from "@repo/ping-react-js";
import { jspreadsheet } from "@jspreadsheet/react";
import parser from "@jspreadsheet/parser";
import { designTokensCssDecl } from "@/lib/design-token-utils";
import {
  hydrateAnonymousPostHogConsent,
  POSTHOG_CONSENT_STORAGE_KEY,
  preparePostHogConsent,
} from "utils/analyticsConsent";

jspreadsheet.setLicense(JSS_LICENSE_KEY);
jspreadsheet.setExtensions({ parser });

// Public landing pages also need the design tokens, before any PageLayout mounts.
const designTokensStyle = document.createElement("style");
designTokensStyle.id = "pingDesignTokens";
designTokensStyle.textContent = designTokensCssDecl;
document.head.appendChild(designTokensStyle);

preparePostHogConsent();

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2025-05-24",
  cookieless_mode: "on_reject",
  consent_persistence_name: POSTHOG_CONSENT_STORAGE_KEY,
  cookie_expiration: 365,
  capture_pageview: false,
  advanced_disable_flags: true,
  disable_external_dependency_loading: true,
  __add_tracing_headers: [
    "https://api-dev.sovfixer.com",
    "https://api-staging.pingintel.com",
    "https://api.sovfixer.com",
    "https://app.dev.pingintel.com",
    "https://app.staging.pingintel.com",
    "https://app.pingintel.com",
    "https://app.eu.pingintel.com",
    "https://vision.dev.pingintel.com",
    "https://vision.staging.pingintel.com",
    "https://vision.pingintel.com",
    "https://data-api-dev.sovfixer.com",
    "https://data-api-staging.sovfixer.com",
    "https://data-api.sovfixer.com",
  ],
  // posthog-js has no public flag to disable the toolbar, so leave its extension out.
  __extensionClasses: { toolbar: undefined },
});

hydrateAnonymousPostHogConsent(posthog);

const rootElement = document.getElementById("root")!;
ReactModal.setAppElement(rootElement);

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <AnalyticsWrapper product="ping.maps">
        <Root />
      </AnalyticsWrapper>
    </PostHogProvider>
  </React.StrictMode>,
);
